import withApollo from "../../../lib/withApollo";
import {getDataFromTree} from "@apollo/react-ssr";
import {Button, Col, Input, Modal, ModalBody, Row} from "reactstrap";
import React, {useEffect} from "react";
import DateRangePicker from "./DateRangePicker";
import moment from "moment";
import useWindowSize from "../../../hooks/UseWindowSize";
import {FilterSelection} from "../../../types/filterSelection";
import ModalHeader from "../../Modal/ModalHeader";
import dynamic from "next/dynamic";

interface CottageBottomMenuProps {
    toggle: () => void,
    modal: boolean,
    lowestWeekPrice: number,
    highestWeekPrice: number,
    searchSelection: FilterSelection,
    price: any,
    slug: string,
    availability?: any
    availableNights: number[]
    selectedNights?: number,
    setSelectedNights: (nights: number) => void,
    setRange: ({startDate, endDate}: { startDate: moment.Moment, endDate: moment.Moment }) => void,
}

const encodeBookingDetails = (details) => {
    return Buffer.from(JSON.stringify(details)).toString("base64");
};

const CalendarModal = ({
                           toggle,
                           modal,
                           searchSelection,
                           lowestWeekPrice,
                           highestWeekPrice,
                           price,
                           slug,
                           availability,
                           availableNights,
                           selectedNights,
                           setSelectedNights,
                           setRange
                       }: CottageBottomMenuProps) => {
    const {startDate, endDate} = searchSelection;
    const windowSize = useWindowSize();
    const daySize: number = Math.floor(windowSize.width / 8.5);

    return (
        <Modal fade={false} isOpen={modal} toggle={toggle} className="full-screen-modal modal-dialog-full-width">
            <ModalHeader toggle={toggle}>
                Selecteer een verblijfsduur:
                <div className="mt-2">
                    <Input
                        defaultValue={selectedNights}
                        type="select"
                        name="nights"
                        id="nights"
                        onChange={(e) => setSelectedNights(parseInt(e.target.value))}
                        className="modal-nights-select"
                    >
                        {availableNights.map((nights) => (
                            <option key={nights} value={nights}>{`${nights} ${
                                nights == 1 ? "nacht" : "nachten"
                            }`}</option>
                        ))}
                    </Input>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="ml-4 mr-4 arrival-date-legenda pb-1">
                    <span>
                        <i className="fas fa-circle date-legenda"/>Beschikbare aankomstdatums
                    </span>
                </div>
                <div className="date-range-picker date-range-picker-height-100">
                    <DateRangePicker
                        searchSelection={searchSelection}
                        updateSearchSelection={(searchSelection) => {
                            setRange({
                                startDate: moment(searchSelection.startDate),
                                endDate: moment(searchSelection.endDate)
                            })
                        }}
                        activateOffset={true}
                        orientation="verticalScrollable"
                        daySize={daySize}
                        numberOfMonths={24}
                        availability={availability}
                        selectedNights={selectedNights}
                    />
                </div>
            </ModalBody>
            <div className="mobile-search-menu text-center">
                <Row>
                    <Col className="text-left pl-4 pt-2">
                        {price && searchSelection.hasRangeSelection() &&
                            <>
                                <p>
                                    <strong className="text-sm">
                                        {price.nights} nachten<br/>
                                        € {price.price},-
                                    </strong>
                                </p>
                            </>
                        }
                        {/*{(!dates.hasRangeSelection() || !price) &&*/}
                        {/*<strong className="text-sm text-secondary mt-3">*/}
                        {/*    €{lowestWeekPrice}-€{highestWeekPrice} per week*/}
                        {/*</strong>*/}
                        {/*}*/}
                    </Col>
                    <Col className="text-right">
                        <Button
                            disabled={!searchSelection.hasRangeSelection()}
                            onClick={toggle}
                            size="sm"
                            aria-label="Boek cottage"
                            className="book-button my-2 mx-2"
                            color="primary"
                        >
                            {(!searchSelection.hasRangeSelection() || !price) &&
                                <>Kies een aankomstdatum
                                    {" "}
                                </>
                            }
                            {(searchSelection.hasRangeSelection() && price) &&
                                <>Terug naar cottage
                                    {" "}
                                </>
                            }
                        </Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    )
}

export default withApollo(CalendarModal, {getDataFromTree});
